import documentWrapper from './document';

fetchCart()

var interactivityrequested = false;

function interactivityRequesed(){
  if(interactivityrequested) return
  let body = document.querySelector('body')
  interactivityrequested = true
  appendStyle(body.dataset.asyncStyle);
  insertImages('high')
  insertImages('low')
  let asyncScriptsDataset = body.dataset.asyncScripts
  let asyncScripts = body.dataset.asyncScripts ? asyncScriptsDataset.split(',') : []
  asyncScripts.forEach(script => {
    appendScript(script, {})
  })
}

/* page not on top initiated load */

var scrollTop = documentWrapper.getScrollTop()

if(scrollTop > 60 ){
  interactivityRequesed()
}

/* scroll initiated async load */

window.addEventListener('scroll', scrollOnce)

function scrollOnce(event){
  interactivityRequesed()
  document.removeEventListener('scroll', scrollOnce)
}

/* time cosistenty interactive initiated load */

ttiPolyfill.getFirstConsistentlyInteractive()
  .then(function(tti){
    if(!tti){
      setTimeout(function(){ 
        interactivityRequesed()
      }, 5000)
      return;
    }
    interactivityRequesed()
  })

function appendStyle(src){
  return new Promise(function(resolve, reject){
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = src;
    link.type = 'text/css';
    link.onload = resolve
    link.onerror = reject
    document.head.appendChild(link)
  })
}

function appendScript(src, options){
  return new Promise(function(resolve, reject){
    if(!options) options = {};

    var script = document.createElement('script');
    script.src= src;
    if(options.async) script.async = true;
    script.type = 'text/javascript';
    script.onload = resolve;
    script.onerror = reject;

    if(options && options.text){
      script.text = options.text;
    };

    var sibling = document.getElementsByTagName('script')[1];
    sibling.parentNode.insertBefore(script, sibling);
  })
}

function insertImages(priority){
  let selector = 'img[data-c-src]'

  if(priority == 'high'){
    selector += '[data-priority="high"]'
  } else {
    selector += ':not([data-priority="high"])'
  }

  let collection = document.querySelectorAll(selector);

  collection.forEach(img => {

    if(img.dataset.cSrc !== null){
        img.src = img.dataset.cSrc
    }

    if(img.dataset.cSrcset) img.srcset = img.dataset.cSrcset;

    if("loading" in HTMLImageElement.prototype){
      img.loading = "eager";
    }
  })

  if(priority !== 'high'){
    document.querySelectorAll('video source').forEach(source => {
      if(!source.hasAttribute('data-c-src')) return
        source.src = source.dataset.cSrc;
      })

    document.querySelectorAll('video').forEach(function(video){
      video.load()
    })
  }
}

function fetchCart(){
  var req = new XMLHttpRequest();

  req.open('GET', '/cart.js')

  req.send()  

  req.onload = function(res){
    var elem = document.querySelector('.c-cart-items')
    var cart = JSON.parse(res.srcElement.response)

    if(elem && cart.item_count != parseInt(elem.innerHTML)){
      elem.innerHTML = cart.item_count
    }
  }
}

export default {
  interactivityRequested: interactivityRequesed
}
